import { Flex, Select, Typography } from "antd";
import React, { useState } from "react";
import { authAxios } from "../utils/session_utils";
const { Text } = Typography;

let timeout: ReturnType<typeof setTimeout> | null;
let currentValue: string;

const fetchData = (value: string, callback: (data: { value: string; label: string }[]) => void) => {
	if (timeout) {
		clearTimeout(timeout);
		timeout = null;
	}
	currentValue = value;

	const fetchRefIdData = async () => {
		try {
			const config = {
				method: "get",
				url: `${process.env.REACT_APP_BACK_END_API}/snowflake/getRefIds/${currentValue}`,
			};
			const response = await authAxios(config);
			console.log(response);
			const { rows } = response.data;
			callback(rows);
		} catch (err) {
			console.error("error in getRefId data in episode", err);
		}
	};
	if (value) {
		timeout = setTimeout(fetchRefIdData, 300);
	} else {
		callback([]);
	}
};

const SearchByRefId = ({
  value,
  onChange,
  isFromIndexPage,
  setEpisodeId
}: {
  value?: string;
  onChange?: (val: string, option: any) => void;
  isFromIndexPage?: boolean;
  setEpisodeId?: any;
}) => {
	const [data, setData] = useState<{ value: string; label: string }[]>([]);
	const [title, setTitle] = useState<string>();

	const handleSearch = (newValue: string) => {
		fetchData(newValue, setData);
	};

	const handleChange = (newValue: string, selectedOption: any) => {
		onChange?.(newValue, selectedOption);
		setEpisodeId?.(selectedOption?.episode_id)
		const titles = selectedOption?.meta_titles || [];

		// Try to find English title (case-insensitive)
		const englishTitleObj = titles.find(
			(item: any) =>
				item.language?.toLowerCase() === "english" || item.language?.toLowerCase() === "en"
		);

		const fallbackTitleObj = titles[0];

		setTitle(englishTitleObj?.title || fallbackTitleObj?.title || "");
	};
	return (
		<Flex vertical>
			<Select
				showSearch
				value={value}
				placeholder={"Enter RefId"}
				defaultActiveFirstOption={false}
				suffixIcon={null}
				filterOption={false}
				onSearch={handleSearch}
				onChange={handleChange}
				notFoundContent={null}
				options={data}
				disabled={!isFromIndexPage}
			/>
            <Text type="secondary">{title}</Text>
		</Flex>
	);
};

export default SearchByRefId;
